import { HTTP } from './HttpService'

export const AuthService = {
  verifyAccess() {
    return HTTP.get('/auth/verify-access')
  },
}
